import React, { useState, useEffect } from "react";
import { MdPhoneIphone, MdOutlineEmail, MdKeyboardBackspace } from "react-icons/md";
import { IoAlert, IoKeySharp } from "react-icons/io5";
import { renderToString } from 'react-dom/server'
import { cloneDeep } from 'lodash';

import classes from './ChooseRecoveryMethod.module.scss'

import PasswordRecoveryWrapper from "../PasswordRecoveryWrapper";
import {Alert} from "react-bootstrap";

export const recoveryMethods = [
    {
        typeId: 4,
        icon: <MdPhoneIphone />,
        promptText: 'По номеру телефона',
        name: 'Номер телефона',
        maxLength: 7,
        maskRecoveryValidationRules: [
            {
                required: true,
                message: 'Введите недостающую часть номера телефона!',
            },
            {
                pattern: /^\d{7,}$/g,
                message: 'Некорректный формат номера телефона!',
            },
        ]
    },
    {
        typeId: 6,
        icon: <MdOutlineEmail />,
        promptText: 'По e-mail',
        name: 'E-mail',
        maxLength: 320,
        maskRecoveryValidationRules: [
            {
                required: true,
                message: 'Введите недостающую часть электронной почты!',
            },
            {
                pattern: /^(?=.{1,28}$)([\.\-\_]?[A-Za-z0-9])+([\.\-\_]?[A-Za-z0-9])*$/gi,
                message: 'Некорректный формат электронной почты!',
            },
        ]
    },
]

const ChooseRecoveryMethod = (props) => {
    const [contactsList, setContactsList] = useState([])
    const [selectedContact, setSelectedContact] = useState(null)
    const [ifUnmount, setIfUnmount] = useState(false)

    const setContainerStylesOnUnmount = () => {
        if (ifUnmount) return { opacity: 0, transform: 'translateY(20px)' }
        else return { opacity: 1, transform: 'translateY(0)' }
    }

    const setComponentHeader = () => {
        if (props.location.state?.contacts?.length !== 0)
            return { icon: <IoKeySharp size={35} /> }
        else return { icon: <IoAlert size={45} />, color: "#f44336" }
    }

    useEffect(() => {
        if (props.location.state?.contacts && props.location.state?.login && props.location.state?.numberOfAttempts) {
            let tmp = cloneDeep(props.location.state.contacts)
            tmp = tmp.map(contact => ({ ...contact, ...recoveryMethods.find(method => method.typeId === contact.contactTypeId) }))
            setContactsList(tmp)
        } else props.history.push("/password-recovery")
    }, [props.location, props.history])

    useEffect(() => {
        if (selectedContact) {
            setIfUnmount(true)
            setTimeout(() => {
                props.history.push({
                    pathname: "/password-recovery/mask",
                    state: {
                        contact: { ...selectedContact, icon: renderToString(selectedContact.icon) },
                        login: props.location.state?.login
                    }
                })
            }, 400);
        }
    }, [selectedContact, props.history, props.location])

    return (
        <PasswordRecoveryWrapper
            title="Восстановление пароля"
            {...setComponentHeader()}>
            <button className={classes.goBackButton} onClick={() => props.history.goBack()}>
                <MdKeyboardBackspace size={35} />
            </button>
            <div className={classes.container} style={setContainerStylesOnUnmount()}>
                {contactsList.length !== 0
                    ? <React.Fragment><div className={classes.extra}>Выберите способ восстановления</div>
                        <div style={{ marginTop: '15px' }}>
                            {contactsList.map((contact, index) => <div
                                key={index}
                                className={classes.contactContainer}
                                onClick={() => setSelectedContact(contact)}>
                                <div className={classes.contactValueIconContainer}>{contact.icon}</div>
                                <div className={classes.contactValueContainer}>
                                    <div className={classes.contactValuePromptText}>{contact.promptText}</div>
                                    <div>
                                        <b>{contact.contactValue}</b>
                                    </div>
                                </div>
                            </div>)}
                        </div>
                    </React.Fragment>
                    : <div className={classes.alertInformation}>
                        {`Контакты, привязанные к учетной записи, отсутствуют. Для актуализации контактных данных необходимо `}<br />
                        <b>обратиться в деканат</b>.
                    </div>
                }
            </div>
            <Alert style={{marginTop: "30px", textAlign: 'justify'}} variant="info">
                <p>
                    Если у вас <span style={{textDecoration: "underline"}}>изменились почта или телефон</span> для
                    восстановления пароля, <b>обратитесь в деканат</b> вашего факультета для обновления данных.
                </p>
            </Alert>
        </PasswordRecoveryWrapper>
    )
}

export default ChooseRecoveryMethod;